import React from 'react';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import styled from 'styled-components/native';

import { EDataTestId } from '@webtrader/core/constants/test';
import dynamicSize from '@webtrader/core/dynamic-size';

import Text from '@/components/Text';

interface IValidationErrorProps {
  showValidation: boolean;
  message: string;
}

const ValidationError: FCC<IValidationErrorProps> = (props) => {
  const { showValidation, message } = props;

  if (!showValidation) {
    return null;
  }

  return (
    <ValidationContainer>
      <StyledMaterialIcons name="error-outline" size={14} />
      <FormValidation testID={EDataTestId.INPUT_FIELD_VALIDATION}>{message}</FormValidation>
    </ValidationContainer>
  );
};

export default ValidationError;

const ValidationContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

const FormValidation = styled(Text)`
  margin: 4px;

  font-size: ${dynamicSize.convertSize(12)}px;
  font-weight: 400;

  color: ${({ theme }) => theme.colors.error[0]};
`;

const StyledMaterialIcons = styled(MaterialIcons)`
  color: ${({ theme }) => theme.colors.error[0]};
`;
